export default {
  address: "Adres",
  bank_number: "Iban",
  email: "E-mailadres",
  dob: "Geboortedatum",
  relation_number: "Relatienummer",
  id: "Intern relatienummer",
  label: "Label",
  name: "Naam",
  first_name: "Voornaam",
  postal_code: "Postcode",
  phone: "Telefoonnummer",
};
